import React, { LazyExoticComponent, Suspense, lazy } from 'react';

import ErrorBoundary from './error-boundary';

type LazyCallback = () => Promise<{ default: React.ComponentType<any> }>;

function MyLazyComponent(callback: LazyCallback, fallback = <></>) {
  const LazyComponent: LazyExoticComponent<React.ComponentType<any>> = lazy(callback);
  return (data: any) => {
    return (
      <Suspense fallback={fallback}>
        <ErrorBoundary>
          <LazyComponent {...data} />
        </ErrorBoundary>
      </Suspense>
    );
  };
}

export default MyLazyComponent;
